import FJClothesChangerLeft from './FJClothesChangerLeft';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionClothesChanger from '../../../redux/action/FJActionClothesChanger';
import { useCallback } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJConstant from '../../../constants/FJConstant.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE,
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../config/dataConfig/FJGenerateData.js';
const FJClothesChangerLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const peopleImageInfo = useSelector(state => state.clothesChanger.peopleImageInfo);
    const clothesImageInfo = useSelector(state => state.clothesChanger.clothesImageInfo);
    const selectedName = useSelector(state => state.clothesChanger.selectedStyle);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const tab = useSelector(state => state.clothesChanger.tab);
    const selectedModel = useSelector(state => state.clothesChanger.selectedModel);

    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionClothesChanger.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
    }, [dispatch, taskStatus]);

    const _onUploadImage = useCallback(
        (file, isClothesImage) => {
            dispatch(FJActionClothesChanger.uploadImageAction(file, isClothesImage));
        },
        [dispatch],
    );
    const _openMediaLibrary = useCallback(
        target => {
            dispatch(
                FJActionEditPage.openMediaLibraryAction({
                    uploadConfig: {
                        isMultiple: false,
                        maxMediaNum: 1,
                        selectedMediaIds: [],
                        acceptTypeWithTranscode: UPLOAD_FILE_TYPE + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                        acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                        suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                        // 媒体库的过滤规则
                        mediaFilterFunc: item => {
                            const mediaTypes = ['IMAGE'];
                            return mediaTypes.includes(item.type);
                        },
                        // 上传文件之后返回的数据
                        callbackOptions: {
                            target: target,
                        },
                    },
                }),
            );
        },
        [dispatch],
    );

    const _onTabChange = useCallback(
        tab => {
            dispatch(FJActionClothesChanger.setTabAction(tab));
        },
        [dispatch],
    );

    const _onModelChange = useCallback(
        model => {
            dispatch(FJActionClothesChanger.setSelectedModelAction(model));
        },
        [dispatch],
    );

    const _onClearImage = useCallback(
        isClothesImage => {
            dispatch(FJActionClothesChanger.clearImageAction(isClothesImage));
        },
        [dispatch],
    );

    return (
        <FJClothesChangerLeft
            openMediaLibrary={_openMediaLibrary}
            creditNumber={creditNumber}
            taskStatus={taskStatus}
            onGenerate={_onGenerate}
            freeNumCreation={freeNumCreation}
            peopleImageInfo={peopleImageInfo}
            clothesImageInfo={clothesImageInfo}
            onUploadImage={_onUploadImage}
            isProjectLoading={isProjectLoading}
            selectedName={selectedName}
            tab={tab}
            onTabChange={_onTabChange}
            onModelChange={_onModelChange}
            selectedModel={selectedModel}
            onClearImage={_onClearImage}
        />
    );
};
export default FJClothesChangerLeftContainer;
